import { ServerApi } from 'modules/api/server-api';

import { Language } from '@/models/BaseTypes';

export const fetchLanguages = (api: ServerApi) => async () => {
  const response = await api.get('/dictionary/languages');
  return response.data.languages as Language[];
};
